import React, { useEffect, useId, useState } from 'react';
import { useDispatch } from 'react-redux';
import { uploadFileActions } from '../_actions/uploadFile.actions';

function InputFile({ name, path, ['path-to-upload']: uploadPath }) {
  const dispatch = useDispatch();
  const inputId = `file-upload-${useId().replace(/:/g, '')}`;
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null);
      return undefined;
    }

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  function handleChange(event) {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    setFile(selectedFile);
    dispatch(uploadFileActions.upload(selectedFile, uploadPath));
  }

  const imagePath = previewUrl || path;

  return (
    <div className="input-file">
      <label htmlFor={inputId} className="custom-file-upload">
        {imagePath ? (
          <img src={imagePath} alt={name || 'logo'} />
        ) : (
          'Custom Upload'
        )}
      </label>
      <input id={inputId} type="file" name={name} onChange={handleChange} />
    </div>
  );
}

export default InputFile;
